<lms-breadcrumb
  [crumbs]="[
    { icon: 'glicon-filing-box', label: 'customizations.label', route: '/customizations' },
    { route: '.', label: document.name }
  ]"
></lms-breadcrumb>

<div class="col s12" *ngIf="questions">
  <lms-dynamic-form [questions]="questions" (submit)="updateDocument($event)"></lms-dynamic-form>
</div>

<lms-toolbar>
  <div class="lms-toolbar__item">
    <gl-button
      color-primary
      [routerLink]="['/questions/new']"
      [queryParams]="{ documentId: document?.id, clientId: document?.clientId }"
      [disabled]="disableNewQuestion"
      [text]="'documents.questions.add' | translate"
      title="{{ (disableNewQuestion ? null : 'documents.questions.add') | translate }}"
    ></gl-button>
  </div>
</lms-toolbar>

<div class="col s12" *ngIf="document">
  <h3 class="h3 margin-bottom-none">{{ 'customizations.documents.detail.questionList' | translate }}</h3>
  <lms-questions-list
    [listId]="questionsListId"
    [options]="{ filters: filters }"
    (onListUpdated)="verifyList($event)"
  ></lms-questions-list>
</div>
